import React from 'react';

import Tile from '../Tile';

import { isWeekend } from '../shared/dates';
import {
	formatDay as defaultFormatDay,
	formatLongDate as defaultFormatLongDate,
} from '../shared/dateFormatter';
import { getMonth, endOfDay, startOfDay } from 'date-fns';

const className = 'FSHCalendarView__month-view__days__day';

type DayProps = {
	classes?: string[];
	currentMonthIndex: number;
	formatDay?: typeof defaultFormatDay;
	formatLongDate?: typeof defaultFormatLongDate;
} & Omit<React.ComponentProps<typeof Tile>, 'children' | 'formatAbbr' | 'view'>;

export default function Day({
	classes = [],
	currentMonthIndex,
	formatDay = defaultFormatDay,
	formatLongDate = defaultFormatLongDate,
	...otherProps
}: DayProps) {
	const { date, locale } = otherProps;

	const classesProps: string[] = [];

	if (classes) {
		classesProps.push(...classes);
	}

	if (className) {
		classesProps.push(className);
	}

	if (isWeekend(date, locale)) {
		classesProps.push(`${className}--weekend`);
	}

	if (getMonth(date) !== currentMonthIndex) {
		classesProps.push(`${className}--neighboringMonth`);
	}

	return (
		<Tile {...otherProps} classes={classesProps} formatAbbr={formatLongDate}>
			{formatDay(locale, date)}
		</Tile>
	);
}
